<template lang="pug">
v-card
  v-chip.chip(v-if="!value.showResult" color="guide" text-color="white" small) New
  v-card-title(primary-title)
    div.headline {{ value.theme.title }}
  v-divider
  v-card-actions
    v-spacer
    text-answered-at.mr-1.caption(
      v-if="value.showResult"
      :value="value.answer.answered_at")
    btn-icon.ml-2(
      v-if="value.showResult"
      icon="themeResult"
      iconColor="green accent-4"
      :tooltip="$t('text.showResults')"
      @click="onResult")
    btn-icon.ml-2(
      icon="themeAnswer"
      color="primary"
      :tooltip="$t('text.answer')"
      @click="answer")
</template>

<script>
'use strict'
import Matchingship from '@/models/matchingship'
import Theme from '@/models/theme'
import BtnIcon from '@/components/button/BtnIcon'
import TextAnsweredAt from '@/components/text/TextAnsweredAt'
import TimeSupport from '@/utils/time-support'

export default {
  components: {
    BtnIcon,
    TextAnsweredAt
  },
  props: {
    value: {
      type: Matchingship,
      required: true
    }
  },
  methods: {
    answer () {
      this.$emit('on-answer', this.value)
    },
    onResult () {
      this.$emit('on-result', this.value)
    }
  }
}
</script>

<style lang="styl" scoped>
.chip
  position absolute
  top -12px
</style>
